import React, { useState, useRef } from 'react';
import { MapPin, Phone, Mail, Clock, CheckCircleIcon, LoaderIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
const EMAILJS_SERVICE_ID = 'service_f8m7sc8';
const EMAILJS_TEMPLATE_ID = 'template_df81q2n';
const EMAILJS_PUBLIC_KEY = 'dbgZLeU3eBc84Bedf';
export function Contact() {
  const formRef = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formRef.current) return;
    setStatus('sending');
    try {
      await emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY);
      setStatus('success');
      formRef.current.reset();
      setTimeout(() => setStatus('idle'), 5000);
    } catch (error) {
      console.error('EmailJS error:', error);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 5000);
    }
  };
  return <section id="contact" className="py-24 bg-light-alt" data-id="element-66">
      <div className="container mx-auto px-6 md:px-12" data-id="element-67">
        <div className="bg-white rounded-sm shadow-xl overflow-hidden" data-id="element-68">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-69">
            {/* Contact Info */}
            <div className="bg-primary text-white p-12 lg:p-16 relative overflow-hidden" data-id="element-70">
              <div className="absolute top-0 right-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-71"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-72"></div>

              <div className="relative z-10" data-id="element-73">
                <h3 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-74">
                  Start Your Project
                </h3>
                <p className="text-gray-300 mb-12 text-lg" data-id="element-75">
                  Contact us today for a free initial consultation. Our team of
                  experts is ready to bring your vision to life.
                </p>

                <div className="space-y-8" data-id="element-76">
                  <div className="flex items-start gap-4" data-id="element-77">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-78">
                      <Phone size={24} data-id="element-79" />
                    </div>
                    <div data-id="element-80">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-81">
                        Call or Text for your free estimate
                      </h4>
                      <p className="text-xl font-medium" data-id="element-82">(908) 613 2086</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-83">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-84">
                      <Mail size={24} data-id="element-85" />
                    </div>
                    <div data-id="element-86">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-87">
                        Email
                      </h4>
                      <p className="text-lg font-medium" data-id="element-88">
                        wchomeremodeling8@gmail.com
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-89">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-90">
                      <MapPin size={24} data-id="element-91" />
                    </div>
                    <div data-id="element-92">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-93">
                        Location
                      </h4>
                      <p className="text-lg font-medium" data-id="element-94">Union NJ</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-95">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-96">
                      <Clock size={24} data-id="element-97" />
                    </div>
                    <div data-id="element-98">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-99">
                        Hours
                      </h4>
                      <p className="text-lg font-medium" data-id="element-100">
                        Mon - Fri: 8:00 AM - 6:00 PM
                        <br data-id="element-101" />
                        Sat: 9:00 AM - 2:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="p-12 lg:p-16" data-id="element-102">
              <h3 className="text-2xl font-serif font-bold text-primary mb-8" data-id="element-103">
                Send Us a Message
              </h3>

              <form ref={formRef} className="space-y-6" onSubmit={handleSubmit} data-id="element-104">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-105">
                  <div data-id="element-106">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-107">
                      Full Name
                    </label>
                    <input type="text" name="name" required className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors" placeholder="John Smith" data-id="element-108" />
                  </div>
                  <div data-id="element-109">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-110">
                      Phone
                    </label>
                    <input type="tel" name="Phone" required className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors" placeholder="(555) 000-0000" data-id="element-111" />
                  </div>
                </div>

                <div data-id="element-112">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-113">
                    Email Address
                  </label>
                  <input type="email" name="Email" required className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors" placeholder="john@example.com" data-id="element-114" />
                </div>

                <div data-id="element-115">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-116">
                    Project Type
                  </label>
                  <select name="Project type" required className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors text-gray-700" data-id="element-117">
                    <option value="" data-id="element-118">Select an option</option>
                    <option value="Kitchen Remodel" data-id="element-119">Kitchen Remodel</option>
                    <option value="Bathroom Remodel" data-id="element-120">Bathroom Remodel</option>
                    <option value="Home Addition" data-id="element-121">Home Addition</option>
                    <option value="Full Remodel" data-id="element-122">Full Remodel</option>
                    <option value="Flooring" data-id="element-123">Flooring</option>
                    <option value="Painting" data-id="element-124">Painting</option>
                    <option value="Other" data-id="element-125">Other</option>
                  </select>
                </div>

                <div data-id="element-126">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-127">
                    Project Details
                  </label>
                  <textarea rows={4} name="Detail" className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors resize-none" placeholder="Tell us a little about what you have in mind..." data-id="element-128"></textarea>
                </div>

                <button type="submit" disabled={status === 'sending'} className="w-full bg-accent hover:bg-accent-hover disabled:opacity-70 disabled:cursor-not-allowed text-white font-medium py-4 rounded-sm transition-colors text-lg flex items-center justify-center gap-2" data-id="element-129">
                  {status === 'sending' && <>
                      <LoaderIcon size={20} className="animate-spin" data-id="element-130" />
                      Sending...
                    </>}
                  {status === 'idle' && 'Request a Quote'}
                  {status === 'success' && <>
                      <CheckCircleIcon size={20} data-id="element-131" />
                      Message Sent!
                    </>}
                  {status === 'error' && 'Error — Try Again'}
                </button>

                {status === 'success' && <p className="text-green-600 text-sm text-center font-medium" data-id="element-132">
                    Thank you! We'll get back to you shortly.
                  </p>}
                {status === 'error' && <p className="text-red-600 text-sm text-center font-medium" data-id="element-133">
                    Something went wrong. Please call us at (908) 613 2086.
                  </p>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}